import { Colors, Icon, Typography } from '@amelio/ui-library';

import {
    ManagerAssessmentSkillSelectorOption,
    type ManagerAssessmentSkillSelectorOptionValue,
} from '@/constants/review/ManagerAssessmentSkillSelectorOption';
import { useAmelioTranslations } from '@/hooks';

interface ManagerSkillSelectorTileProps {
    selectedOption?: ManagerAssessmentSkillSelectorOptionValue;
}

export const ManagerSkillSelectorTile = ({ selectedOption }: ManagerSkillSelectorTileProps) => {
    const { t } = useAmelioTranslations();

    if (selectedOption === ManagerAssessmentSkillSelectorOption.DO_NOT_ASSESS_SKILLS) {
        return null;
    }

    const getTileLabel = () => {
        switch (selectedOption) {
            case ManagerAssessmentSkillSelectorOption.ALL_SKILLS:
                return t(
                    'templateManagement.template.managerSkillSelector.options.allSkills.label',
                );
            case ManagerAssessmentSkillSelectorOption.WEAKEST_SKILLS:
                return t(
                    'templateManagement.template.managerSkillSelector.options.weakestSkills.label',
                );
            case ManagerAssessmentSkillSelectorOption.OLDER_THAN_SIX_MONTHS:
                return t(
                    'templateManagement.template.managerSkillSelector.options.olderThanSixMonths.label',
                );
            default:
                return t(
                    'templateManagement.template.managerSkillSelector.options.allSkills.label',
                );
        }
    };

    return (
        <div
            className={'border-secondary w-full rounded-lg border border-dashed bg-purple-100 p-3'}
            data-testid={'manager-skill-selector-tile'}
        >
            <div className={'flex items-center gap-3'}>
                <Icon
                    name={'essential-menu'}
                    color={Colors.SECONDARY_700}
                    strokeWidth={3}
                    size={'lg'}
                />

                <div className={'flex-1 pt-0.5'}>
                    <Typography
                        variant={'h5'}
                        weight={'semibold'}
                        color={Colors.SECONDARY_700}
                    >
                        {getTileLabel()}
                    </Typography>

                    <Typography
                        variant={'body'}
                        color={Colors.SECONDARY_700}
                    >
                        {t('templateManagement.template.managerSkillSelector.tileDescription')}
                    </Typography>
                </div>
            </div>
        </div>
    );
};
